@if (showApplication()) {
  <div class="app-shell">
    @if (isAuthenticated()) {
      <app-header (loginClicked)="onLogin()" (logoutClicked)="onLogout()"></app-header>
    }
    <div class="main body bg-[#F8F9FA]">
      @if (isProcessingStudioLogin()) {
        <div class="app-loading-state">
          <div class="app-loading-card">
            <div class="academy-loading-spinner mx-auto mb-5" aria-hidden="true"></div>
            <h2 class="app-loading-title">Signing you in</h2>
            <p class="app-loading-copy">Loading MindPlay Teacher Academy, please wait.</p>
          </div>
        </div>
      } @else {
        <div class="row no-x-margin h-full">
          <router-outlet></router-outlet>
        </div>
      }
    </div>
  </div>
}
